import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../../common_components/mdae-framework";
import { cloneDeep, cloneDeepWith, first } from "lodash";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_INTERNAL_AUDIT_CASE_LIST } from "../services/get-internal-audit-case-list";
import { GET_CASE_LIST_FOR_PAGE } from "../../case-list-page/services/get-cases-for-list-page";
export const SET_EA_CASE_LIST_DATA = "SET_EA_CASE_LIST_DATA";
export const TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER =
  "TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER";
export const UPDATE_CASE_DETAIL_LIST_DATA = "UPDATE_CASE_DETAIL_LIST_DATA";
export const SET_CURRENT_USER_ACTION_MODE = "SET_CURRENT_USER_ACTION_MODE";
export const SET_INTERNAL_AUDIT_CASE_LIST = "SET_INTERNAL_AUDIT_CASE_LIST";
export const SET_IS_INCOMPLETE_TASK_COUNT_CLICK =
  "SET_IS_INCOMPLETE_TASK_COUNT_CLICK";
export const SET_SELECTED_CASE_DATA = "SET_SELECTED_CASE_DATA";
export const TOGGLE_GROUP_BY_VIEW_SWITCH = "TOGGLE_GROUP_BY_VIEW_SWITCH";
export const SET_VIEW_COMPONENT_LINE_ITEMS = "SET_VIEW_COMPONENT_LINE_ITEMS";
export const SET_HEADER_RANGE_FILTER_COUNT ="SET_HEADER_RANGE_FILTER_COUNT";
export const BULK_UPDATE_CASE_DETAIL_LIST_DATA= "BULK_UPDATE_CASE_DETAIL_LIST_DATA";
export const SET_MARK_AS_SEEN_CASEIDS ="SET_MARK_AS_SEEN_CASEIDS";
export const SET_MARK_AS_UNSEEN_CASEIDS ="SET_MARK_AS_UNSEEN_CASEIDS";
const initialState = {
  eaCaseListData: [],
  showCaseChangesInformation: false,
  internalAuditCaseList: [],
  isInCompleteTaskCountClick: [0, false],
  isShowGroupByRoundView: true,
  isShowChkbxViewCmpnt: false,
  headerRangeFilterCount: 6,
  isNewBillingDataPresentForAudit:false,
  caseIdsMarkedAsSeen:[]
};

const CaseListReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_EA_CASE_LIST_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState.isNewBillingDataPresentForAudit =first(action?.data?.eaCaseListData as any[])?.caseList?.some((x) => x?.newRecordInd === true) || false;
        if (action.data.documentListData) {
          action.data.documentListData.data.documentList.forEach((x) => {
            newState.eaCaseListData[0]?.caseList.forEach((y) => {
              if (
                y.eaCaseId == x.attachedLevelId &&
                x.attachedLevelName == "EAC"
              ) {
                y.documentCount =
                  y.documentCount == null ? 1 : y.documentCount + 1;
              }
            });
          });
        }
        newState = { ...newState, ...action.data };
      }
      return newState;
    case UPDATE_CASE_DETAIL_LIST_DATA:
      newState = cloneDeep(state);
      const currentCaseList = newState.eaCaseListData[0]?.caseList;
      if (currentCaseList && currentCaseList.length) {
        let currentCaseIndex = -1;
        for (let i = 0; i < currentCaseList.length; i++) {
          if (currentCaseList[i].eaCaseId === action.data.eaCaseId) {
            currentCaseIndex = i;
            break;
          }
        }
        const currentCaseListItem = currentCaseList.filter(
          (x) => x.eaCaseId === action.data.eaCaseId
        )[0];
        if (currentCaseListItem) {
          for (var prop in action.data) {
            currentCaseListItem[prop] = action.data[prop];
          }
          newState.eaCaseListData[0].caseList[
            currentCaseIndex
          ] = currentCaseListItem;
        }
      }
      return newState;
    case TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      }else{
        return { ...newState, ...action.data };
      }
      return newState;
    case BULK_UPDATE_CASE_DETAIL_LIST_DATA: {
      const { eaCaseIds, updates } = action.data;
      return {
        ...state,
        eaCaseListData: state.eaCaseListData.map((eaCase, eaIndex) =>
          eaIndex === 0
            ? {
                ...eaCase,
                caseList: eaCase.caseList.map((item) =>
                  eaCaseIds.includes(item.eaCaseId)
                    ? { ...item, ...updates } 
                    : item 
                ),
              }
            : eaCase
        ),
      };
    }
    case SET_MARK_AS_SEEN_CASEIDS:
      return { ...state, caseIdsMarkedAsSeen: [...state.caseIdsMarkedAsSeen,action.data.eaCaseId] };
    case SET_MARK_AS_UNSEEN_CASEIDS:
      return {
        ...state,
        caseIdsMarkedAsSeen: state.caseIdsMarkedAsSeen.filter(
          (id) => id !== action.data.eaCaseId
        ),
      };
    case SET_CURRENT_USER_ACTION_MODE:
      return { ...state, currentUserActionMode: action.currentUserActionMode };
    case SET_INTERNAL_AUDIT_CASE_LIST:
      return { ...state, internalAuditCaseList: action.data };
    case SET_IS_INCOMPLETE_TASK_COUNT_CLICK:
      return {
        ...state,
        isInCompleteTaskCountClick: action.isInCompleteTaskCountClick,
      };
    case SET_SELECTED_CASE_DATA:
      return { ...state, selectedEaCaseId: action.data.selectedEaCaseId };
    case TOGGLE_GROUP_BY_VIEW_SWITCH:
    case SET_VIEW_COMPONENT_LINE_ITEMS:
    case SET_HEADER_RANGE_FILTER_COUNT:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_INTERNAL_AUDIT_CASE_LIST)(action)) {
        return { ...state, internalAuditCaseList: [] };
      }
      if (isAsyncComplete(GET_INTERNAL_AUDIT_CASE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          internalAuditCaseList: response?.map((x) => x.caseId),
        };
      }
      
      if (isAsyncOperation(GET_CASE_LIST_FOR_PAGE)(action)) {
        return {
          ...state,
        };
      }
      if (isAsyncComplete(GET_CASE_LIST_FOR_PAGE)(action)) {
        const response = action.response.eaCaseList;
      
        return {
          ...state,
          eaCaseListData: [
            {
              caseList: response,
            },
          ],
        };
      }
      
      return state;
    default:
      return state;
  }
};

export default CaseListReducer;
